// extracted by mini-css-extract-plugin
export default {"scrollbar":"NftCardBackSlide_scrollbar__+vyGO"};